import React from "react";
import { DetailCalloutProps } from "./DetailCallout.types";
import { Default } from "./variations/Default";
import { Default_v2 } from "./variations/Default_v2";

export const DetailCallout: React.FC<DetailCalloutProps> = ({ content, ...props }) => {
  if (content && content.length > 0) {
    return <Default_v2 content={content} {...props} />;
  }

  return <Default {...props} />;
};
